// FORM
export const issue_view_erp_code = 'issue_view_erp_code'
export const issue_reference_code = 'issue_reference_code'
export const issue_edit_reference_code = 'issue_edit_reference_code'
export const issue_active = 'issue_active'
export const edit_issue_active = 'edit_issue_active'
export const issue_billable = 'issue_billable'
export const edit_issue_billable = 'edit_issue_billable'
export const issue_description = 'issue_description'
export const edit_issue_description = 'edit_issue_description'
export const issue_summary = 'issue_summary'
export const edit_issue_summary = 'edit_issue_summary'
export const issue_owner = 'issue_owner'
export const edit_issue_owner = 'edit_issue_owner'
export const issue_submit_date = 'issue_submit_date'
export const edit_issue_submit_date = 'edit_issue_submit_date'
export const issue_actual_start = 'issue_actual_start'
export const edit_issue_actual_start = 'edit_issue_actual_start'
export const issue_actual_end = 'issue_actual_end'
export const edit_issue_actual_end = 'edit_issue_actual_end'
export const issue_service_category = 'issue_service_category'
export const edit_issue_service_category = 'edit_issue_service_category'
export const issue_service = 'issue_service'
export const edit_issue_service = 'edit_issue_service'
export const issue_assignee = 'issue_assignee'
export const edit_issue_assignee = 'edit_issue_assignee'
export const issue_team = 'issue_team'
export const edit_issue_team = 'edit_issue_team'
export const issue_technicians = 'issue_technicians'
export const edit_issue_technicians = 'edit_issue_technicians'
export const issue_customer = 'issue_customer'
export const edit_issue_customer = 'edit_issue_customer'
export const issue_customer_contact_info = 'issue_customer_contact_info'
export const issue_site = 'issue_site'
export const edit_issue_site = 'edit_issue_site'
export const issue_address = 'issue_address'
export const edit_issue_address = 'edit_issue_address'
export const issue_fm_info = 'issue_fm_info'
export const issue_address_contact = 'issue_address_contact'
export const edit_issue_address_contact = 'edit_issue_address_contact'
export const issue_address_contact_info = 'issue_address_contact_info'
export const issue_project = 'issue_project'
export const edit_issue_project = 'edit_issue_project'
export const issue_serial_number = 'issue_serial_number'
export const edit_issue_serial_number = 'edit_issue_serial_number'
export const issue_sla = 'issue_sla'
export const edit_issue_sla = 'edit_issue_sla'
export const issue_estimated_start = 'issue_estimated_start'
export const edit_issue_estimated_start = 'edit_issue_estimated_start'
export const issue_estimated_end = 'issue_estimated_end'
export const edit_issue_estimated_end = 'edit_issue_estimated_end'
export const issue_duration = 'issue_duration'
export const edit_issue_duration = 'edit_issue_duration'
export const issue_estimated_work = 'issue_estimated_work'
export const edit_issue_estimated_work = 'edit_issue_estimated_work'
export const issue_estimated_cost = 'issue_estimated_cost'
export const edit_issue_estimated_cost = 'edit_issue_estimated_cost'
export const issue_proposed_work = 'issue_proposed_work'
export const edit_issue_proposed_work = 'edit_issue_proposed_work'
export const issue_charge = 'issue_charge'
export const edit_issue_charge = 'edit_issue_charge'
export const issue_priority = 'issue_priority'
export const edit_issue_priority = 'edit_issue_priority'
export const issue_type = 'issue_type'
export const edit_issue_type = 'edit_issue_type'
export const issue_status = 'issue_status'
export const edit_issue_status = 'edit_issue_status'
export const issue_kind = 'issue_kind'
export const edit_issue_kind = 'edit_issue_kind'
export const issue_view_items = 'issue_view_items'
export const edit_issue_view_items = 'edit_issue_view_items'
export const issue_add_items = 'issue_add_items'
export const edit_issue_add_items = 'edit_issue_add_items'
export const issue_delete_items = 'issue_delete_items'
export const edit_issue_delete_items = 'edit_issue_delete_items'
export const issue_edit_items = 'issue_edit_items'
export const edit_issue_edit_items = 'edit_issue_delete_items'
export const issue_items_value = 'issue_items_value'
export const edit_issue_items_value = 'edit_issue_items_value'
export const issue_items_price = 'issue_items_price'
export const edit_issue_items_price = 'edit_issue_items_price'
export const issue_items_total_value = 'issue_items_total_value'
export const edit_issue_items_total_value = 'edit_issue_items_total_value'
export const view_issue_auditing = 'view_issue_auditing'
export const view_financial_info = 'view_financial_info'
export const view_edit_financial_info = 'view_edit_financial_info'
export const issue_actual_charge = 'issue_actual_charge'
export const edit_issue_actual_charge = 'edit_issue_actual_charge'
export const issue_targeted_start = 'issue_targeted_start'
export const edit_issue_targeted_start = 'edit_issue_targeted_start'
export const issue_actual_visit_date = 'issue_actual_visit_date'
export const edit_issue_actual_visit_date = 'edit_issue_actual_visit_date'
export const issue_targeted_end = 'issue_targeted_end'
export const edit_issue_targeted_end = 'edit_issue_targeted_end'

// BUTTONS
export const create_issue = 'create_issue'
export const issue_complete = 'issue_complete'
export const issue_pending = 'issue_pending'
export const issue_inability = 'issue_inability'
export const issue_cancel = 'issue_cancel'
export const edit_closed_issue = 'edit_closed_issue'
export const follow_up_issue = 'follow_up_issue'
export const issue_so_order = 'issue_so_order'

// HISTORY PAGE
export const history_column_erp_code = 'history_column_erp_code'
export const history_column_customer = 'history_column_customer'
export const history_column_assignee = 'history_column_assignee'
export const history_column_project = 'history_column_project'
export const history_filter_customer = 'history_filter_customer'
export const access_history = 'access_history'
export const history_column_actual_charge = 'history_column_actual_charge'
export const history_column_charge = 'history_column_charge'
export const history_column_estimated_end = 'history_column_estimated_end'

// DASHBOARD
export const dashboard_view_customer = 'dashboard_view_customer'
export const dashboard_filter_customer = 'dashboard_filter_customer'
export const dashboard_filter_erp_code = 'dashboard_filter_erp_code'
export const access_dashboard = 'access_dashboard' // Όλοι εκτός Υπεύθυνος Καταστήματος

// CHECK LISTS
export const access_check_lists_form = 'access_check_lists_form' // Μόνο ο Υπεύθυνος Καταστήματος
export const access_check_lists_history = 'access_check_lists_history' // Ο Υπεύθυνος Καταστήματος και ο FM
export const check_lists_filter_site = 'check_lists_filter_site'
export const check_lists_column_site = 'check_lists_column_site'
export const access_questionnaire = 'access_questionnaire'
export const access_questionnaire_history = 'access_questionnaire_history'

// QUICKVIEW
export const quickview_view_erp_code = 'quickview_view_erp_code' // όλοι εκτός από customer
export const quickview_view_assignee = 'quickview_view_assignee' // όλοι εκτός από customer
export const quickview_view_technicians = 'quickview_view_technicians' // FM, Call Center, Manager, Τεχνικός
export const quickview_view_estimated_end = 'quickview_view_estimated_end' // όλοι εκτός από customer
export const quickview_view_financial_info = 'quickview_view_financial_info' // FM, Manager, Πελάτης, Υπεργολάβοσ
export const quickview_view_actual_charge = 'quickview_view_actual_charge' // FM, Πελάτης, Manager
export const quickview_view_charge = 'quickview_view_charge' // FM, Manager, Υπεργολάβος
export const quickview_view_items_value = 'quickview_view_items_value' // FM, Manager, Τεχνικός, Υπεργολάβος
export const quickview_view_items_price = 'quickview_view_items_price' // FM, Manager, Τεχνικός, Υπεργολάβος
export const quickview_view_items_total_value = 'quickview_view_items_total_value' // FM, Manager, Τεχνικός, Υπεργολάβος

// STATISTICS
export const access_statistics = 'access_statistics'
export const statistics_view_completed_within_SLA = 'statistics_view_completed_within_SLA'
export const statistics_view_repeat_wo = 'statistics_view_repeat_wo'
export const statistics_view_mtbf = 'statistics_view_mtbf'
export const statistics_view_nmpi = 'statistics_view_nmpi'
export const statistics_view_asset_cost = 'statistics_view_asset_cost'
export const statistics_view_customer = 'statistics_view_customer'
export const statistics_view_fm = 'statistics_view_fm'
export const statistics_view_assignee = 'statistics_view_assignee'
export const statistics_column_customer = 'statistics_column_customer'
export const statistics_column_fm = 'statistics_column_fm'
export const statistics_view_aging = 'statistics_view_aging'
export const view_po = 'view_po'
export const view_non_completed_checklists = 'view_non_completed_checklists'
export const add_issue_checklist = 'add_issue_checklist'
export const view_checklists = 'view_checklists'
